import { ensureRouteData } from '@/app/query-client'
import { largeHoldingsQueryOptions } from '@/features/brokers/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { largeHoldingsSearchSchema, toLargeHoldingsQuery } from '@/screens/brokers/search'

/**
 * The `/brokers/large-holdings` loader.
 *
 * MAIN: large holdings, keyed on the search object (`period`/`page`/
 * `pageSize`) — the table is the entire page below the period/search row.
 * The stock-or-broker search box filters client-side over whatever page is
 * already on screen (`filterHoldings`), so there is no secondary read.
 *
 * Because main data is keyed on a search param, the screen does NOT read it
 * with a suspense query — `useLargeHoldings` stays plain `useQuery` +
 * `keepPreviousData` — see docs/route-loading.md, "Search params".
 */
export async function loadLargeHoldings({
  context: { queryClient },
  location,
}: {
  context: RouterContext
  location: { search: unknown }
}): Promise<void> {
  const search = largeHoldingsSearchSchema.parse(location.search)
  await ensureRouteData(queryClient, largeHoldingsQueryOptions(toLargeHoldingsQuery(search)))
}
